/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */
// settings saved in firebase
export enum DynamicFlagTypes {
	CREW_SIZE_ENABLED = 'crewSizesEnabled',
	SHARED_MEETING = 'sharedMeeting',
	CLIPBOARD = 'clipboard',
	DASHBOARD = 'dashboard',
	DASHBOARD_PROJECT_LEVEL_ENABLED = 'dashboardProjectLevelEnabled',
	UNDO = 'undo',
	ANALYTICS_SEGMENT_EVENTS = 'analyticsSegmentEvents',
	SIGN_UP_ENABLED = 'signUpEnabled',
	WEB_GL_ENABLED = 'webGlEnabled',

	// feature flags for analytics = under "settings/console/"
	CONSOLE = 'console',
	ANALYTICS_CONSOLE_LOGGING = 'analyticsConsoleLogging',

	// for custom field
	CUSTOM_FIELDS_MAX_NUM = 'customFieldsMaxNum',
	CUSTOM_FIELDS_MATERIAL_GROUP_ENABLED = 'customFieldsMaterialGroupEnabled',

	REFRESH_FOR_NEW_VERSION_ENABLED = 'refreshForNewVersionEnabled',

	// scheduling
	PROJECT_SCHEDULE_ENABLED = 'projectSchedulingEnabled',

	// Project partitioning
	PROJECT_PARTITIONING_ENABLED = 'projectPartitioningEnabled',
	// addition of the time-zone dropdown to Project Info dialog, and "timezoneId" to project FB data:
	PROJECT_TIME_ZONE_ENABLED = 'projectTimeZoneEnabled',

	// file attach
	FILE_ATTACH_ENABLED = 'fileAttachEnabled',
	FILE_ATTACH_SUFFIXES = 'fileAttachSuffixes',
	FILE_ATTACH_SIZE_LIMIT_IN_MB = 'fileAttachSizeLimitInMB',

	//adjust pull ticket width
	WIDE_PULL_TICKET = 'widePullTicketEnabled',

	// Numbers of tickets to load before and after today in ngMobile's ticket-list
	TICKET_LIST_LOAD_BEFORE_TODAY = 'ticketListLoadBeforeToday',
	TICKET_LIST_LOAD_AFTER_TODAY = 'ticketListLoadAfterToday',

	// Organizations
	ORGANIZATION_ENABLED = 'organizationEnabled',

	// Used in checkForFeatureFlagExpiry function
	SIGNED_ATTACHMENTS_EXPIRATION = 'signedAttachmentUrlExpirationInSeconds',

	// Ticket import
	TICKET_IMPORT_ENABLED = 'ticketImportEnabled',

	// Ticket import
	TICKET_IMPORT_V2_ENABLED = 'ticketImportV2Enabled',

	// Reports Logo
	REPORT_LOGO_ENABLED = 'reportLogoEnabled',
	ENABLE_GCS_TICKET_ATTACHMENTS_PATH_SEGMENT = 'enableGCSTicketAttachmentsPathSegment',

	// Enables setting and editing the linkage-type and lag attributes of dependencies between tickets
	TICKET_DEPENDENCY_LINKAGE_TYPE_AND_LAG = 'ticketDependencyLinkageTypeAndLag',

	// Enables setting for the "Modern Timeline", which is powered by canvas and not DOM elements
	MODERN_TIMELINE_ENABLED = `modernTimelineEnabled`,

	// Enables ticket export
	TICKET_EXPORT_ENABLED = 'ticketExportEnabled',

	// Enables the csv report
	CSV_REPORT_ENABLED = 'csvReportEnabled',

	// Mark projects as "Archived" in Desktop
	MARK_PROJECTS_AS_ARCHIVED_IN_DESKTOP = 'markProjectsAsArchivedInDesktop',

	// Master schedule mode enabled
	MASTER_SCHEDULE_ENABLED = 'masterScheduleEnabled',

	// Docked ticket in desktop
	DOCKED_TICKET_IN_DESKTOP_ENABLED = 'dockedTicketInDesktopEnabled',

	// Plan Actions
	PLAN_ACTIONS_HOVER_OVER = 'planActionsHoverOver',

	// Enables Swimlane Reports
	SWIMLANES_REPORT_ENABLED = 'swimlanesReportEnabled',

	// Enables the Custom Fields multi-select in Reports
	CUSTOM_FIELDS_REPORT_ENABLED = 'customFieldsReportEnabled',

	// Enables the WBS Code feature in Tickets and Reports
	TICKETS_WBS_ENABLED = 'ticketsWBSEnabled',

	// Enables Project Settings (Data Source Editor)
	PROJECT_SETTINGS_ENABLED = 'projectSettingsEnabled',

	// Enables Touchplan format data sources in Import Tickets
	TOUCHPLAN_FORMAT_ENABLED = 'touchplanFormatEnabled',

	// Enables ESID report filter
	EXTERNAL_LINKAGE_REPORT_FILTER_ENABLED = 'externalLinkageReportFilterEnabled',

	// Enables the WBS Code filter in Reports
	WBS_CODE_FILTER_ENABLED = 'wbsCodeFilterEnabled',

	// Enables the idle timeout to logout the user
	IDLE_TIMEOUT_ENABLED = 'idleTimeoutEnabled',

	// Enables OPC Export Format dropdown option
	OPC_EXPORT_FORMAT_ENABLED = 'opcExportFormatOptionEnabled',

	// Enables MS Project Export Format dropdown option
	MSP_EXPORT_FORMAT_ENABLED = 'mspExportFormatOptionEnabled',

	// Enables the Plan Archive feature (UI-wise)
	PLAN_ARCHIVE_ENABLED = 'planArchiveEnabled',

	// Enables additional links for Admin and Basic User Resources in support dropdown
	SUPPORT_DROPDOWN_ADDITIONAL_RESOURCE_LINKS_ENABLED = 'supportDropdownAdditionalResourceLinksEnabled',

	// Enable boardscan integration
	BOARDSCAN_ENABLED = 'boardscanEnabled',

	// Enable plan printing/plan export functionality
	PLAN_PRINT_ENABLED = `planPrintEnabled`,

	// Enable Granular Time Planning
	FBDB_GTP_ENABLED = 'fbdbGTPEnabled',
	FBDB_GTP_ENABLED_BY_PROJECT = 'fbdbGTPEnabledByProject',

	// Enable Maximum Zoom Level in GTP
	GTP_ENABLE_MAXIMUM_ZOOM = 'gtpEnableMaximumZoom',
}
